"use client"
import React,{useState} from 'react'

type Delivery = {
    title: string;
    description: string;
    img: string;
    fullDes: string;
    closeIconType?: string
  };
  

  
export default function Customers() {
    const [selectedDelivery, setSelectedDelivery] = useState<Delivery | null>(null);
    const deliveries = [
        {
          title: "Package deliveries",
          description:
          "Experience fast and reliable delivery with A-Swift. Whether you're sending or receiving package locally in your city across Canada. A-Swift guarantees safe, on-time,same day deliveries, with ...",
            fullDes: "Experience fast and reliable delivery With A-Swift. Whether you're sending or receiving package locally in your city across Canada. A-Swift guarantees safe, on-time,same day deliveries, with real time tracking. We bring trusted delivery solutions to communities accross the country.",
          img: "/assets/wwd-1.svg",
          closeIconType: 'white'
        },
        {
          title: "Retail",
          description:
            "Explore your favourite local stores in your city with A-Swift's retail delivery. From beauty products to fashion and groceries, we connect you with your favourite local businesses ....",
            fullDes: "Explore your favourite local stores in your city with A-Swift's retail delivery. From beauty products to fashion and groceries, we connect you with your favourite local businesses, bringing the best of local shopping to your door.",
          img: "/assets/wwd-2.svg",
            closeIconType: 'white'
        },
        {
          title: "Business",
          description:
            "A-Swift offers businesses a seamless dashboard to track deliveries in real time and enhance customer satisfaction. Save time and money with efficient deliveries desi...",
            fullDes: "A-Swift offers businesses a seamless dashboard to track deliveries in real time and enhance customer satisfaction. Save time and money with efficient deliveries designed for Saskatoon's local businesses",
          img: "/assets/wwd-3.svg",
          closeIconType: 'white'
        },
        {
          title: "Facebook Marketplace",
          description:
            "Easily request a driver to pick up an item you buy on Facebook Marketplace and have it delivered to your doorstep in minutes.",
            fullDes: "Easily request a driver to pick up an item you buy on Facebook Marketplace and have it delivered to your doorstep in minutes.",
          img: "/assets/wwd-4.svg",
        },
        {
          title: "Real-time Tracking",
          description:
            "Track your deliveries in real-time with Aswift’s cutting-edge tracking technology. Know exactly where your package is and ability to call or chat your driver on our mobile app .....",
            fullDes: "Track your deliveries in real-time with A-Swift’s cutting-edge tracking technology. Know exactly where your package is and ability to call or chat your driver on our mobile app from pick-up to drop-off, so you're always in control.",
          img: "/assets/wwd-5.svg",
        },
        {
          title: "24/7 Customer Support",
          description:
            "Our customer support team is here for you—anytime you need help. Aswift offers 24/7 assistance to ensure your deliveries go smoothly and all your questions are answered",
            fullDes: "Our customer support team is here for you—anytime you need help. Aswift offers 24/7 assistance to ensure your deliveries go smoothly and all your questions are answered",
          img: "/assets/wwd-6.svg",
        },
      ];


      const handleDeliveryClick = (delivery: any) => {
        setSelectedDelivery(delivery);
      };
    
      const closeModal = () => {
        setSelectedDelivery(null);
      };
  return (
    <div className=" bg-[#fdfdfd] grid grid-cols-1 md:grid-cols-3 gap-x-7 gap-y-10 py-5">
    {deliveries.map((delivery, index) => (
      <div key={index} className="bg-white cursor-pointer" onClick={() => handleDeliveryClick(delivery)}>
        <img src={delivery.img} className="w-full rounded-t-[15px]" />
        <div className="bg-white shadow-md rounded-bl-[10px] rounded-br-[10px] h-auto md:h-[250px] lg:h-auto min-h-[200px]">
          <div className="max-w-[400px]  px-3 py-5">
            <h2 className="text-xl sb-ac text-gray-800 mb-2">
              {delivery.title}
            </h2>
            <p className="text-gray-600 text-[15px]">
              {delivery.description}
            </p>
          </div>
        </div>
      </div>
    ))}



{selectedDelivery && (
        <div className="fixed inset-0 flex flex-row pt-[40px] md:pt-[50px] justify-center bg-black bg-opacity-50 px-5 md:px-0" onClick={closeModal}>
          <div className="w-[450px] rounded-[15px]  relative " >
            <button onClick={closeModal} className="absolute top-5 right-5 text-gray-500 hover:text-gray-700">
            <img src={selectedDelivery.closeIconType === 'white' ? "/assets/cancel-w.svg" : "/assets/cancel-ss.svg"} />
            </button>
            <img src={selectedDelivery.img} className="w-full h-[250px] md:h-[350px]  rounded-t-[15px] object-cover" alt={`${selectedDelivery.title} larger view`} />
            <div className='bg-white rounded-[15px] flex flex-col justify-center  items-center py-5 mt-[-20px] absolute px-5'> 
                  <div className='absolute top-[-20px] md:top-[-30px] right-[-10px] md:right-[-20px]'> 
                    <img src="/assets/cms.svg" className='w-[140px] md:w-auto' />
                  </div>
            <h2 className="text-[26px] sb-ac text-gray-800 mb-2 pt-9">{selectedDelivery.title}</h2>
            <p className="text-gray-600 text-[18px] max-w-[600px]  mx-auto text-center pb-10">{selectedDelivery.fullDes}</p>
            </div>
          </div>
        </div>
      )}

  </div>
  )
}